import React, { PureComponent } from "react";

class SelectProduct extends PureComponent {

    render() {

      /*ValidarPantalla es una variable en el store que cambia de estado permitiendo evaluar todas las validaciones*/
      const { selectComboProducto, Validaciones, ValidarPantalla, ProductoId, GET_PRODUCTOS } = this.props;

      let mensajeError = null;

      const optionProductos = GET_PRODUCTOS.map((producto, index) => {
        return (
        <option key={"producto-opt" + index} value={producto.Id}>
            {producto.Nombre}
        </option>
        );
      });

      if (ValidarPantalla == true) {
        if (Validaciones.ProductoSeleccionado == false) {
                mensajeError = <label className="error">Debe seleccionar al menos un producto</label>;
        }
      }

      return (
      <div className="row bottom-separator-xs">
        <div className="col-xs-6">
            <div className="marked">
                <label className="label-primary">Producto</label>
                <select className="form-control default-select" value={ProductoId}
                    onChange={(event) => { selectComboProducto(event.target.value, "PRODUCTOS") }}>
                    <option value="0">Seleccione...</option>
                    {optionProductos}
                </select>
            </div>
            {mensajeError}
        </div>
      </div>
      );

    }
    
}

export default SelectProduct;